export const dropdown = {
    bg: 'white',
    border: {
        radius: '2px',
        width: 0,
    },
    boxShadow: '0 1px 6px 0 rgba(0, 0, 0, 0.1)',
    font: 'body-regular-asphalt',
    hovered: {
        bg: 'cloud',
    },
    maxHeight: '250px',
    withPointer: false,
};
//# sourceMappingURL=dropdown.js.map